export default __webpack_public_path__ + "static/media/bg-beach.9de46747.jpg";